// extracted by mini-css-extract-plugin
export default {"permissions-overlay":"permissions-overlay__O7EI0","permissions":"permissions__SnVOQ"};